'use strict'

var Marionette = require('marionette')
var App = require('app')

var TimelineComponent = require('src/components/timeline-view')

/**
 * Layout
 * -----------------------------------------------------------------------------
 */
var Layout = Marionette.View.extend({
  template: require('./templates/layout.html'),
  regions: {
    timelineRegion: '.device-events__region'
  },
  triggers: {
    'click .js-add': 'schedule:add',
    'click .js-next': 'timeline:next'

  },

  templateContext: function () {
    return {
      getLastSeenAt: App.TemplateHelpers.getLastSeenAt,
      userHasRole: App.TemplateHelpers.userHasRole,
      getConditionalStr: App.TemplateHelpers.getConditionalStr
    }
  }
})

module.exports.Layout = Layout

/**
 * Timeline item
 * -----------------------------------------------------------------------------
 */
var TimelineListItemView = TimelineComponent.TimelineListItemView.extend({
  template: require('./templates/timeline-list-item.html'),
  className: function () {
    return 'timeline__item ' + this.model.get('type')
  }
})

/**
 * Timeline Collection View
 * -----------------------------------------------------------------------------
 */
var TimelineCollectionView = TimelineComponent.TimelineCollectionView.extend({
  childView: TimelineListItemView
})

/**
 * Timeline Layout
 * -----------------------------------------------------------------------------
 */
var TimelineLayoutView = TimelineComponent.TimelineLayoutView.extend({
  childView: TimelineCollectionView
})

module.exports.TimelineView = TimelineLayoutView



// WEBPACK FOOTER //
// ./js/modules/device-events/show/view.js